import axios from "@app/Security/AxiosAuthentication";
import htmlParser from "@app/utils/htmlParser";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import ProducerAddressInterface, { AddressType } from "@app/Interface/ProducerAddressInterface";
import AddressUpdateModel from "@app/Model/AddressupdateModel";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class ProducerAddressHelper {

    static getAddresses = async (controller: AbortController, fpuId: number, pageId: number): Promise<ProducerAddressInterface[]> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + ApiEndpoints.PRODUCER_ADDRESS + `?page=1&fpu_id=${fpuId}&page_id=${pageId}`;

        return await axios.get(url, {
            withCredentials: true,
            signal: controller.signal
        })
            .then(response => {

                const dataItems: ProducerAddressInterface[] = response.data["hydra:member"];

                const addresses = ProducerAddressHelper.getProducerAddressesFromResponseData(dataItems);

                return addresses;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "getAddresses()");

                // return an empty set of navItems
                const emptyItems: Array<ProducerAddressInterface> = [];

                return emptyItems;

            });

    }

    /**
     * Transforms/udates data fields, such as htmlDecode on strings 
     * @param dataItems 
     * @returns 
     */
    static getProducerAddressesFromResponseData = (dataItems: ProducerAddressInterface[]): ProducerAddressInterface[] => {

        dataItems.forEach(address => {

            if (typeof address.street1 === "string") {
                address.street1 = htmlParser.htmlDecode(address.street1);
            } else {
                address.street1 = "";
            }

            if (typeof address.street2 === "string") {
                address.street2 = htmlParser.htmlDecode(address.street2);
            } else {
                address.street2 = "";
            }

            if (typeof address.city === "string") {
                address.city = htmlParser.htmlDecode(address.city);
            } else {
                address.city = "";
            }

            if (typeof address.state === "string") {
                address.state = htmlParser.htmlDecode(address.state);
            } else {
                address.state = "";
            }

            if (typeof address.postal === "string") {
                address.postal = htmlParser.htmlDecode(address.postal);
            } else {
                address.postal = "";
            }

        });

        return dataItems;

    }

    /*
     * Save address to Middleware endpoint
     * @param addressData 
     * @returns 
     */
    static sendAddressUpdateNotification = async (addressData: ProducerAddressInterface): Promise<number | boolean> => {

        const baseUrl: string = process.env.API_BASEURL ?? "";

        const url = baseUrl + ApiEndpoints.ADDRESS_UPDATE_NOTIFICATION;

        const updateData = new AddressUpdateModel();

        let addressTypeDescription = "Farm";

        if (addressData.type === AddressType.Mailing) {
            addressTypeDescription = "Mailing";
        }

        updateData.fpuID = addressData.producerId;
        updateData.address1 = addressData.street1;
        updateData.address2 = addressData.street2;
        updateData.city = addressData.city;
        updateData.state = addressData.state;
        updateData.zip = addressData.postal;
        updateData.addressType = addressTypeDescription;

        // update the address
        return axios.post(url, updateData, {
            withCredentials: true
        })
            .then(response => {

                return response.status;

            })
            .catch(error => {

                RollbarHelper.logRequestError(error, "sendAddressUpdateNotification()");

                return false;

            });

    }

}